<template>
  <div class="image-text" :style="{'background': content.background}">
    <div class="image-text__content">
      <h1 class="image-text__title">{{ content.title }}</h1>
      <p class="image-text__text">{{ content.text }}</p>
    </div>

    <div class="image-text__image">
      <scroll-speed :speed="this.content.parallax">
          <img slot-scope="{}" :src="content.image" />
      </scroll-speed>
    </div>
  
  
  </div>
</template>

<script>
import ScrollSpeed from '@/components/scroll-speed'

export default {
  name: "ImageText",
  components: {ScrollSpeed},
  props: {
    content: Object
  },
};
</script>


<style scoped lang="scss">
@import "../scss/globals.scss";

.image-text {
  @extend %page-margin-1;

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;

  min-height: 100vh;
  box-sizing: border-box;

  &__content {
    @extend %page-margin-1;

    width: 100%;
    padding-top: $margin1-1;
    padding-bottom: $margin1-1;
    box-sizing: border-box;

    @media screen and (min-width: 1024px) {
      width: 47%;
    }
  }

  &__title {
    @include typeset(display-2);
    @include typeface(expanded);

    @extend %title-margin-2;

    max-width: 20em;
    margin-bottom: rem(24);
  }

  &__text {
    @include typeset(body-large);

    max-width: 35em;
  }

  &__image {
    width: 100%;

    @media screen and (min-width: 1024px) {
      width: 50%;
    }

    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
